import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42.95 42.27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M37.27 10.16c.12-3.07-.53-5.67-2.07-7.56-4.72-5.61-16.01-1.83-25.11 8.39C.93 21.22-2.61 34.04 2.05 39.65c4.73 5.62 16.01 1.89 25.17-8.33 1.42-1.65 2.78-3.37 3.9-5.08l-15.07-1.53 21.81-2.84-24.05-3.43 29.13-3.01-23.75-2.42 18.08-2.84",
      style: {"fill":"#fcaf1e","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "9W-logo"}) } }